import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import partition from "lodash/partition";
import SvgIcon from "@components/icon/svg";
import ImgSwiper from "@components/x-slider";
import { updateUserFav } from "@shared/apis/user";
import SkImageUrl from "@zhenguo/sk-image-url";
import { RoomTagTypes } from "@shared/consts/app";
import RoomTagList from "./tag-list";
import Price from "./price";

const PromotionTypesMap = {
  [RoomTagTypes.PROMO]: true,
  [RoomTagTypes.MARKETING]: true,
};

export class Product extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      imgIdx: 0,
      favValue: props.defaultFavValue,
    };
    this.avatarConverter = new SkImageUrl({
      modifiers: { w: 100, h: 100, c: 1, e: 1, Q: 60 },
    });
  }

  componentWillReceiveProps(nextProps) {
    const { favValue } = this.state;
    if (nextProps.showFavButton && !(favValue === true || favValue === false)) {
      this.setState({
        favValue: nextProps.defaultFavValue,
      });
    }
  }

  getRentTypeText() {
    const { rentType, rentLayoutRoom, layoutRoom, rentLayoutDesc, bedCount } = this.props.product || {};
    if (rentType === 0) {
      return "整套";
    }
    if (rentType === 1) {
      const room = rentLayoutRoom || layoutRoom;
      if (room) {
        const map = "零单二三四五六七八九十";
        return (map[room] || room) + "间";
      }
    }
    if (rentType === 2) {
      return rentLayoutDesc || ["床位", bedCount && `${bedCount}个`].filter(Boolean).join("");
    }
    return "";
  }

  render() {
    const { product, showCity, showAvatar, showFavButton } = this.props;
    const isFavControlled = !!this.props.onFavValueChange;
    const favValue = isFavControlled ? this.props.favValue : this.state.favValue;
    const { productId, productTagList, price, discountPrice } = product;
    const tagList = productTagList || [];
    const [normalTags, promoTags] = partition(tagList, ({ bizType }) => !PromotionTypesMap[bizType]);
    const hasTags = normalTags.length;
    const hasAvatar = showAvatar && product.hostAvatarUrl;
    const images = product.productImages || [];
    const showDesc = this.props.showDesc && (product.description || product.detail);
    return (
      <a
        className={cx("product-card", {
          "product-card--has-avatar": hasAvatar,
          "product-card--has-tags": hasTags,
        })}
        href={`/housing/${productId}/`}
        target="_blank"
        title={product.title}
        data-goods-id={productId}
        onClick={this.props.onLinkClick}
      >
        <figure>
          <div className="product-card__header">
            <div className="slider-wrapper product-card__slider">
              <ImgSwiper slides={images.map(item => ({ src: item }))} />
            </div>
            {!product.productHotDesc || <span className="room-hot-desc">{product.productHotDesc}</span>}
            {!hasAvatar || (
              <img
                className="product-card__avatar"
                src={this.avatarConverter.convert(product.hostAvatarUrl)}
                alt="房东头像"
              />
            )}
            {!(showFavButton && (favValue === true || favValue === false)) || (
              <button
                type="button"
                className={`product-card__fav product-card__fav--${favValue ? "unfav" : "fav"}`}
                onClick={e => {
                  e.stopPropagation();
                  e.nativeEvent.stopImmediatePropagation();
                  e.preventDefault();
                  if (this.props.isLoginUser === false) {
                    window.alert("请先登录");
                    return;
                  }
                  const newFavValue = !favValue;
                  updateUserFav(product.productId, newFavValue).then(res => {
                    if (res.body.status === 0) {
                      if (isFavControlled) this.props.onFavValueChange(newFavValue);
                      else this.setState({ favValue: newFavValue });
                    } else if (res.body.status === 401) {
                      window.alert("请先登录");
                    }
                  });
                }}
              >
                <SvgIcon symbol={favValue ? require("@shared/icons/fav-fill.svg") : require("@shared/icons/fav.svg")} />
              </button>
            )}
          </div>
          <figcaption>
            {!hasTags || (
              <div className="product-card__row product-card__row--tags">
                <RoomTagList tags={normalTags} />
              </div>
            )}
            <div className="product-card__row product-card__row--title">
              <div
                className={cx("product-card__title", "ellipsis", {
                  "product-card__title--no-padding": !hasAvatar || hasTags,
                })}
              >
                {product.title}
              </div>
            </div>

            {!showDesc || (
              <div className="product-card__row product-card__row--desc">
                <div
                  className="product-card__desc"
                >{product.description}{product.detail}
                </div>
              </div>
            )}
            <div className="product-card__row product-card__row--info">
              {!product.starRating || (
                <span className="room-prop room-prop--rating">{(product.starRating / 10).toFixed(1)}分</span>
              )}
              <span className="room-prop">
                {[this.getRentTypeText(), product.layoutDesc].filter(Boolean).join(" · ")}
              </span>
              <span className="room-prop">{product.guestNumberDesc}</span>
              <span className="room-prop">{product.distanceDesc || product.locationArea || product.districtName}</span>
              {!(showCity && product.cityName) || <span className="room-prop">{product.cityName}</span>}
            </div>
            <div className="product-card__row product-card__row--foot">
              <span className="room-prop room-prop--price">
                <i className="currency">¥</i>
                {(discountPrice || discountPrice === 0 ? discountPrice : price) / 100}
              </span>
              {!(discountPrice || discountPrice === 0) || (
                <del className="room-prop room-prop--original-price">
                  <i className="currency">¥</i>
                  {price / 100}
                </del>
              )}
              {promoTags.length ? (
                <RoomTagList properties={["promo"]} tags={promoTags} ignoreStyles={true} />
              ) : (
                <Fragment>
                  {!product.favCountDesc || <span className="room-prop">{product.favCountDesc}</span>}
                  {!product.viewCountDesc || <span className="room-prop">{product.viewCountDesc}</span>}
                </Fragment>
              )}
            </div>
          </figcaption>
        </figure>
      </a>
    );
  }
}

Product.defaultProps = {
  showCity: false,
  showAvatar: true,
  showFavButton: true,
  favValue: undefined,
  defaultFavValue: undefined,
  onFavValueChange: null,
  onLinkClick: undefined,
  isLoginUser: undefined,
  priceComponent: Price,
  showDesc: false,
};

Product.propTypes = {
  product: PropTypes.object.isRequired,
  showCity: PropTypes.bool,
  showAvatar: PropTypes.bool,
  showFavButton: PropTypes.bool,
  favValue: PropTypes.bool,
  defaultFavValue: PropTypes.bool,
  onFavValueChange: PropTypes.func,
  onLinkClick: PropTypes.func,
  isLoginUser: PropTypes.bool,
  priceComponent: PropTypes.func,
  showDesc: PropTypes.bool,
};

export default Product;

require("./card.less");